import { useEffect, useState } from "react";
import { CiMail, CiUser } from "react-icons/ci";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import logo from "../../assets/logo-2.png";
import Input from "../ui/Input";
import { PhoneNumber } from "../ui/PhoneNumber";
import { Link, useNavigate } from "react-router";
import { userType } from "../../helper/constant";
import { validEmail } from "../../helper/appConstant";
import SelectField from "../ui/SelectField";
import MultiSelectCheckbox from "../ui/MultiSelectCheckbox";
import {
  checkEmailOrPhoneNumberExistOrNot,
  registrationUser,
  sentOtp,
  socialLogin,
} from "../../store/slice/auth";
import { useDispatch, useSelector } from "react-redux";
import OtpDialog from "../dialogs/OtpDialog";
import { useGoogleLogin } from "@react-oauth/google";
import googleIcon from "../../assets/google.png";
import AuthRightSection from "./AuthRightSection";
import UserTypeDialog from "../dialogs/UserTypeDialog";
import ConfirmationDialog from "../dialogs/ConfirmationDialog";
import Button from "component/ui/Button";
import Cookies from "js-cookie";
import secureLocalStorage from "react-secure-storage";

export default function Signup() {
  const dispatch = useDispatch();
  const fcmToken = secureLocalStorage.getItem(
    process.env.REACT_APP_FCM_TOKEN_KEY
  )
    ? secureLocalStorage.getItem(process.env.REACT_APP_FCM_TOKEN_KEY)
    : Cookies.get(process.env.REACT_APP_FCM_TOKEN_KEY);

  const navigate = useNavigate("");
  const [formData, setFormData] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [focusedInput, setFocusedInput] = useState(null);
  const [currentImage, setCurrentImage] = useState(0);
  const [isOTPDialogOpen, setIsOTPDialogOpen] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [userTypeData, setUserTypeData] = useState(userType);
  const { userExistingRoles } = useSelector((state) => state.auth);
  const [userTypeDialogOpen, setUserTypeDialogOpen] = useState(false);
  const [socialData, setSocialData] = useState({});

  const images = [
    "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=800&h=1000&fit=crop",
    "https://images.unsplash.com/photo-1516321497487-e288fb19713f?w=800&h=1000&fit=crop",
    "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?w=800&h=1000&fit=crop",
  ];

  useEffect(() => {
    if (userExistingRoles) {
      setUserTypeDisable();
    }
  }, [userExistingRoles]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [images.length]);

  const setUserTypeDisable = () => {
    let data = [...userTypeData];
    data.map((item, index) => {
      if (userExistingRoles.includes(item?.id)) {
        data[index].disable = true;
      } else {
        data[index].disable = false;
      }
    });
    setUserTypeData(data);
  };

  const verifyPhoneEmail = () => {
    const data = {
      email: formData?.email || "",
      phoneNumber: formData?.phoneNumber || "",
      countryCode: formData?.phoneNumber ? formData?.countryCode : "",
    };
    dispatch(checkEmailOrPhoneNumberExistOrNot(data));
  };

  const handleSendVerificationCode = () => {
    const data = {
      email: formData?.email || "",
      password: formData?.password,
      phoneNumber: formData?.phoneNumber || "",
      countryCode: formData?.phoneNumber ? formData?.countryCode : "",
      userType: formData?.userType,
    };
    dispatch(sentOtp(data, setIsOTPDialogOpen));
  };
  const handleSignup = (e) => {
    if (!formData?.phoneNumber && !formData?.email) {
      setFormData(() => ({
        ...formData,
        phoneEmailError: "Please enter email or phone number.",
      }));
      return;
    }
    if (formData?.email && !validEmail(formData?.email)) {
      setFormData(() => ({
        ...formData,
        emailError: "Please enter valid email.",
      }));
      return;
    }
    if (!formData?.password) {
      setFormData(() => ({
        ...formData,
        passwordError: "Please enter password.",
      }));
      return;
    }
    if (formData?.password && formData?.password?.length < 8) {
      setFormData(() => ({
        ...formData,
        passwordError: "Password must have a minimum 8 characters.",
      }));
      return;
    }
    if (!formData?.name) {
      setFormData(() => ({
        ...formData,
        nameError: "Please enter name.",
      }));
      return;
    }
    if (!formData?.userType) {
      setFormData(() => ({
        ...formData,
        userTypeError: "Please select user type.",
      }));
      return;
    }
    if (formData?.password && formData?.password.length < 8) {
      setFormData(() => ({
        ...formData,
        passwordError: "Password must be minumum 8 characters.",
      }));
      return;
    }
    handleSendVerificationCode();
  };

  const onRegistration = () => {
    const data = {
      name: formData?.name,
      email: formData?.email || "",
      userType: formData?.userType,
      password: formData?.password,
      deviceToken: fcmToken,
      deviceId: "",
      deviceType: "Web",
      phoneNumber: formData?.phoneNumber || "",
      countryCode: formData?.phoneNumber ? formData?.countryCode : "",
    };

    dispatch(registrationUser(data, navigate, setIsOTPDialogOpen));
  };

  const loginGoogle = useGoogleLogin({
    flow: "implicit", // ensures you get the access token
    scope: "openid email profile",
    onSuccess: async (tokenResponse) => {
      // Fetch user info using the access token
      try {
        const res = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        );
        const user = await res.json();
        setSocialData(() => ({
          ...socialData,
          socialAccessToken: tokenResponse.access_token,
          user: user,
          socialId: user.sub,
        }));
        onSocialLogin(tokenResponse.access_token, user, user.sub);
      } catch (err) {
        console.error("Failed to fetch user info", err);
      }
    },
    onError: (err) => {
      console.error("Login Failed:", err);
    },
  });

  const onSocialLogin = (socialAccessToken, user, socialId) => {
    const data = {
      fullName: user?.name,
      email: user?.email,
      deviceToken: fcmToken,
      socialAccessToken: socialAccessToken,
      socialId: socialId,
      userType: formData?.userType || null,
      diviceType: "WEB",
    };

    dispatch(
      socialLogin(
        data,
        setUserTypeDialogOpen,
        verifyPhoneEmail,
        navigate,
        setIsDialogOpen
      )
    );
  };

  return (
    <div className="min-h-screen w-full bg-gray-50 flex items-center justify-center p-4">
      <div className="container w-full mx-auto rounded-md flex overflow-hidden bg-white">
        {/* Left Section */}
        <AuthRightSection />
        {/* Right Section */}
        <div className="w-full md:p-5 p-3 md:w-1/2 flex flex-col justify-center bg-white relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#2BACE2] via-[#057BB5] to-[#2BACE2]"></div>

          <div className="mb-5 flex justify-center animate-fade-in">
            <img src={logo} alt="Logo" className="w-48" />
          </div>

          <h2 className="text-3xl font-medium text-gray-800 text-center bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text">
            Create Account
          </h2>
          <p className="text-gray-500 font-normal text-sm mt-2 text-center mb-5">
            Sign up to get started with your account
          </p>

          <div className="space-y-4">
            <div className="relative group">
              <div className="relative focus-visible:outline-none">
                <Input
                  onFocus={() => setFocusedInput("email")}
                  onBlur={() => {
                    setFocusedInput(null);
                    verifyPhoneEmail();
                  }}
                  placeholder="Email"
                  disabled={formData?.phoneNumber}
                  inputClassName="w-full pl-4 pr-12 py-3 placeholder:text-sm text-sm transition-all duration-300 bg-gray-50 hover:bg-white relative  "
                  onChange={(val) =>
                    setFormData(() => ({
                      ...formData,
                      email: val,
                      emailError: "",
                      phoneEmailError: "",
                    }))
                  }
                  error={formData?.emailError}
                />
                <div
                  className={`absolute right-4 top-1/2 -translate-y-1/2 transition-colors duration-300 ${
                    focusedInput === "email"
                      ? "text-[#2BACE2]"
                      : "text-gray-400"
                  }`}
                >
                  <CiMail size={20} />
                </div>
              </div>
            </div>

            <p className="mx-auto text-center my-1">OR</p>

            <div className="space-y-4">
              <PhoneNumber
                inputClassName="w-full !py-3 placeholder:text-sm text-sm transition-all duration-300 !bg-gray-50 hover:bg-white relative  "
                disabled={formData?.email}
                onBlur={verifyPhoneEmail}
                onChange={(val) =>
                  setFormData(() => ({
                    ...formData,
                    ...val,
                    phoneError: "",
                    phoneEmailError: "",
                  }))
                }
                error={formData?.phoneError}
              />
              {/* </div> */}
            </div>
            {formData?.phoneEmailError && (
              <div className="text-red-400 text-sm">
                {formData?.phoneEmailError}
              </div>
            )}

            <div className="relative group">
              <div className="relative !focus-visible:outline-none">
                <Input
                  type={showPassword ? "text" : "password"}
                  onFocus={() => setFocusedInput("password")}
                  onBlur={() => setFocusedInput(null)}
                  placeholder="Password"
                  inputClassName="w-full pl-4 pr-12 py-3 placeholder:text-sm text-sm transition-all duration-300 bg-gray-50 hover:bg-white relative  "
                  onChange={(val) =>
                    setFormData(() => ({
                      ...formData,
                      password: val,
                      passwordError: "",
                    }))
                  }
                  error={formData?.passwordError}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className={`absolute right-4 top-1/2 -translate-y-1/2 transition-all duration-300 ${
                    focusedInput === "password"
                      ? "text-[#2BACE2]"
                      : "text-gray-400"
                  } hover:text-[#2BACE2]`}
                >
                  {showPassword ? (
                    <IoEyeOutline size={20} />
                  ) : (
                    <IoEyeOffOutline size={20} />
                  )}
                </button>
              </div>
            </div>

            <div className="relative group focus-visible:outline-none">
              <Input
                onFocus={() => setFocusedInput("name")}
                onBlur={() => setFocusedInput(null)}
                placeholder="Full Name"
                inputClassName="w-full pl-4 pr-12 py-3 placeholder:text-sm text-sm transition-all duration-300 bg-gray-50 hover:bg-white relative  "
                onChange={(val) =>
                  setFormData(() => ({
                    ...formData,
                    name: val,
                    nameError: "",
                  }))
                }
                error={formData?.nameError}
              />
              <div
                className={`absolute right-4 top-1/2 -translate-y-1/2 transition-colors duration-300 ${
                  focusedInput === "name" ? "text-[#2BACE2]" : "text-gray-400"
                }`}
              >
                <CiUser size={20} />
              </div>
            </div>
            <MultiSelectCheckbox
              id="categories"
              options={userTypeData}
              value={formData?.userType ? formData?.userType : ""}
              onChange={(val) =>
                setFormData(() => ({
                  ...formData,
                  userType: val,
                  userTypeError: "",
                }))
              }
              placeholder="Select categories"
              focusedInput={focusedInput}
              setFocusedInput={setFocusedInput}
            />

            <div className="flex justify-center pt-2">
              <Button className="w-full" onClick={handleSignup}>
                Sign Up
              </Button>
            </div>

            <p className="text-sm text-gray-700 my-0 text-center">
              By signing up, you agree to our{" "}
              <Link to="/" className="text-[#2BACE2] underline">
                {" "}
                Terms & Conditions
              </Link>{" "}
              and{" "}
              <Link to="/" className="text-[#2BACE2] underline">
                Privacy Policy.
              </Link>{" "}
            </p>
          </div>

          <div className="flex justify-center">
            <p className="mt-3 text-sm text-gray-600">
              Already have an account?{" "}
              <a
                className="text-[#2BACE2] font-semibold text-sm transition-colors duration-300 relative group"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/login")}
              >
                Log in
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#2BACE2] group-hover:w-full transition-all duration-300"></span>
              </a>
            </p>
          </div>

          <div className="relative my-4">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-gray-200"></div>
            </div>
            <div className="relative flex justify-center text-sm">
              <span className="px-4 bg-white text-gray-500">
                Or continue with
              </span>
            </div>
          </div>

          <div className="flex justify-center gap-6 pb-8">
            <button
              className="flex items-center gap-2 px-4 py-2 bg-white text-[#2BACE2] border border-[#2BACE2] font-semibold rounded-full shadow-lg transform transition duration-300 hover:bg-[#e8f2ff] active:scale-95"
              onClick={() => loginGoogle()}
            >
              <img src={googleIcon} width={"30px"} />
              <span>Sign in with Google</span>
            </button>
          </div>
        </div>
        {isOTPDialogOpen && (
          <OtpDialog
            isOTPDialogOpen={isOTPDialogOpen}
            closeDialog={() => setIsOTPDialogOpen(false)}
            formData={formData}
            afterValidate={onRegistration}
            handleResend={handleSendVerificationCode}
          />
        )}

        <ConfirmationDialog
          isDialogOpen={isDialogOpen}
          buttonShow={["OK"]}
          closeDialog={() => {
            setIsDialogOpen(false);
          }}
        />
        {userTypeDialogOpen && (
          <UserTypeDialog
            closeDialog={() => {
              setUserTypeDialogOpen(false);
            }}
            loginGoogle={() => {
              setUserTypeDialogOpen(false);
              onSocialLogin(
                socialData.socialAccessToken,
                socialData.user,
                socialData.socialId
              );
            }}
            userTypeData={userTypeData}
            setFormData={setFormData}
            formData={formData}
          />
        )}
      </div>
    </div>
  );
}
